import { createSlice } from '@reduxjs/toolkit';
import { translationApi } from '@services/api/translation.api';

export interface TranslationState {
  translations: Record<string, string>;
}

const initialState: TranslationState = {
  translations: {},
};

export const translationSlice = createSlice({
  name: 'translation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(translationApi.endpoints.getTranslations.matchFulfilled, (state, { payload }) => {
      state.translations = payload.payload;
    });
  },
});

export default translationSlice.reducer;
